/* DF FIT — Wishlist (favoritos) via localStorage */
(function () {
  var KEY = 'df_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('df:wishlist:change', { detail: list }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var l = read(); var i = l.indexOf(handle);
    if (i === -1) l.push(handle); else l.splice(i, 1);
    write(l);
    return i === -1;
  }

  function refreshButtons() {
    document.querySelectorAll('[data-df-fav]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-fav', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function refreshCount() {
    var n = read().length;
    document.querySelectorAll('[data-df-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  // Clique nos corações (delegação — pega botões carregados dinamicamente)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-df-fav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-handle'));
  });

  document.addEventListener('df:wishlist:change', function () { refreshButtons(); refreshCount(); });

  function init() { refreshButtons(); refreshCount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.DFWishlist = { has: has, toggle: toggle, list: read, count: function () { return read().length; } };
})();
